import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';


@Injectable()
export class AuthService { 
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private apiUrl = 'api';  // URL to web api
    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    userVerify(userData: any,ipData: any): Promise<any[]> {
        this.headers.set('ipAddress', ipData);
        return this.http
            .post(this.apiUrl+'/userVerify', $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    systemVerify(userData: any): Promise<any[]> {

        const url = 'http://localhost:3000/api/systemVerify';
        const headers = new Headers({ 'Content-Type': 'application/json' });

        return this.http
            .post(url, { data: userData }, { headers })  // Wrapping userData inside "data"
            .toPromise()
            .then(res => res as any)
            .catch(this.handleError);
    }
     
    login(userData: any,ipData: any): Promise<any[]> {
        this.headers.set('ipAddress', ipData);
        return this.http
            .post(this.apiUrl+'/login', $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    loginVerification(userData: any,ipData: any): Promise<any[]> {
        this.headers.set('ipAddress', ipData);
        return this.http
            .post(this.apiUrl+'/loginVerification', $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    


    isauth(query: any): Observable<any[]> {
        //ONE BROWSER ON TAB TO BE USED
        query['browserTabId'] = sessionStorage.tabID ? sessionStorage.tabID : sessionStorage.tabID = Math.random();
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }
        
        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/isauth`;
        return this.http.get(url, options)
            .map(res => res.json())
            .catch(err => [JSON.parse(err._body)])
    }

    logout(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/logout`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    generateOtp(query: any) {
        // let params: URLSearchParams = new URLSearchParams();
        // for (let key in query) {
        //     params.set(key.toString(), query[key]);
        // }

        // let options = new RequestOptions({
        //     headers: this.headers,
        //     search: params
        // });

        const url = `${this.apiUrl}/generateOtp`;
        // return this.http.post(url, options)
        //     .toPromise()
        //     .then(this.extractData)
        //     .catch(this.handleError);

            return this.http
            .post(url, $.param(query), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
            
    }

    public getIPAddress()
    {      
      return this.http.get('https://geolocation-db.com/json/');
    }

    private handleError(error: any): Promise<any> {
        //console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/auth.service.ts